import { useQuery } from '@tanstack/react-query';
import { accountDeletionService } from '@/services/api/accountDeletion.service';
import { useFlag } from '@/hooks/useFlags';

export const deletionStatusKey = ['account-deletion', 'status'] as const;
export const deletionPreviewKey = ['account-deletion', 'preview'] as const;

/** The `account_deletion` flag. Off while loading or unreadable, so a screen behind it is never shown on a guess. */
export const useAccountDeletionFlag = () => useFlag('account_deletion');

/** Whether the business is pending deletion. `enabled` is the flag: nothing is requested while it is off. */
export function useDeletionStatus(enabled = true) {
  return useQuery({ queryKey: deletionStatusKey, queryFn: accountDeletionService.status, enabled, staleTime: 30_000, refetchOnWindowFocus: true, retry: false });
}

/** What deleting the business removes (owner). Fresh each time the warning opens: the counts are live. */
export function useDeletionPreview(enabled = true) {
  return useQuery({ queryKey: deletionPreviewKey, queryFn: accountDeletionService.preview, enabled, staleTime: 0, gcTime: 0, retry: false });
}
